import React from 'react';

const css = `
  @media (max-width: 768px) {
    .contact-section {
      padding: 80px 20px !important;
    }
    .contact-heading { font-size: clamp(2.3rem, 11vw, 3rem) !important; }
    .contact-sub { margin-bottom: 36px !important; }
    .contact-email {
      font-size: 1.3rem !important;
      word-break: break-word !important;
      margin-bottom: 44px !important;
    }
    .contact-save {
      display: block !important;
      width: fit-content !important;
      margin: 24px auto 0 !important;
      font-size: 0.72rem !important;
    }
    .contact-resume {
      display: block !important;
      width: fit-content !important;
      margin: 24px auto 0 !important;
      padding: 11px 20px !important;
      font-size: 0.72rem !important;
    }
    .contact-footer-wrap { padding: 0 20px 32px !important; }
  }
`;

const styles = {
  section: {
    padding: '120px 60px',
    maxWidth: '800px',
    margin: '0 auto',
    textAlign: 'center',
  },
  label: {
    fontFamily: "'Outfit', sans-serif",
    fontSize: '0.7rem',
    letterSpacing: '0.35em',
    textTransform: 'uppercase',
    color: '#c9a96e',
    marginBottom: '24px',
    display: 'block',
  },
  heading: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: 'clamp(3rem, 7vw, 6rem)',
    fontWeight: 300,
    lineHeight: 1,
    color: '#f5f2ee',
    marginBottom: '24px',
  },
  headingItalic: {
    fontStyle: 'italic',
    color: '#c9a96e',
  },
  sub: {
    fontFamily: "'Outfit', sans-serif",
    fontSize: '0.9rem',
    fontWeight: 300,
    color: '#6b6560',
    marginBottom: '56px',
    lineHeight: 1.8,
  },
  emailLink: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: 'clamp(1.2rem, 3vw, 2rem)',
    fontWeight: 300,
    color: '#f5f2ee',
    letterSpacing: '0.05em',
    borderBottom: '1px solid rgba(201,169,110,0.3)',
    paddingBottom: '4px',
    transition: 'color 0.2s ease, border-color 0.2s ease',
    display: 'inline-block',
    marginBottom: '0',
  },
  saveLink: {
    display: 'block',
    width: 'fit-content',
    margin: '28px auto 0',
    fontFamily: "'Outfit', sans-serif",
    fontSize: '0.65rem',
    fontWeight: 500,
    letterSpacing: '0.25em',
    textTransform: 'uppercase',
    color: '#6b6560',
    textDecoration: 'none',
    borderBottom: '1px solid rgba(201,169,110,0.2)',
    paddingBottom: '3px',
    transition: 'color 0.2s ease',
  },
  resumeLink: {
    display: 'block',
    width: 'fit-content',
    margin: '28px auto 0',
    fontFamily: "'Outfit', sans-serif",
    fontSize: '0.7rem',
    fontWeight: 500,
    letterSpacing: '0.25em',
    textTransform: 'uppercase',
    color: '#f5f2ee',
    textDecoration: 'none',
    border: '1px solid rgba(201,169,110,0.45)',
    padding: '12px 26px',
    transition: 'background 0.25s ease, color 0.25s ease, border-color 0.25s ease',
  },
  footer: {
    marginTop: '100px',
    paddingTop: '40px',
    borderTop: '1px solid rgba(255,255,255,0.05)',
    fontFamily: "'Outfit', sans-serif",
    fontSize: '0.65rem',
    letterSpacing: '0.2em',
    textTransform: 'uppercase',
    color: '#2a2520',
    display: 'flex',
    justifyContent: 'space-between',
  },
};

export default function Contact() {
  return (
    <section id="contact">
      <style>{css}</style>
      <div className="contact-section" style={styles.section}>
        <span style={styles.label}>Get In Touch</span>
        <h2 className="contact-heading" style={styles.heading}>
          Let's work<br />
          <span style={styles.headingItalic}>together</span>
        </h2>
        <p className="contact-sub" style={styles.sub}>
          For representation inquiries, casting, and collaborations.
        </p>

        <a
          href="/resume.pdf"
          className="contact-resume"
          style={styles.resumeLink}
          onMouseEnter={e => (e.currentTarget.style.color = '#c9a96e')}
          onMouseLeave={e => (e.currentTarget.style.color = '#6b6560')}
        >
          Download Résumé
        </a>

        <a
          href="mailto:NoahSatoBusinessContact@Gmail.com"
          className="contact-email"
          style={styles.emailLink}
          onMouseEnter={e => { e.target.style.color = '#c9a96e'; e.target.style.borderColor = '#c9a96e'; }}
          onMouseLeave={e => { e.target.style.color = '#f5f2ee'; e.target.style.borderColor = 'rgba(201,169,110,0.3)'; }}
        >
          NoahSatoBusinessContact@Gmail.com
        </a>

        <a
          href="/noah-sato.vcf"
          download="Noah Sato.vcf"
          className="contact-save"
          style={styles.saveLink}
          onMouseEnter={e => (e.currentTarget.style.color = '#c9a96e')}
          onMouseLeave={e => (e.currentTarget.style.color = '#6b6560')}
        >
          Save Contact
        </a>
      </div>

      <footer className="contact-footer-wrap" style={{ padding: '0 60px 40px', maxWidth: '1100px', margin: '0 auto' }}>
        <div style={styles.footer}>
          <span>Noah Sato</span>
          <span>© {new Date().getFullYear()}</span>
        </div>
      </footer>
    </section>
  );
}
